import { Component, Input, OnInit } from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { IRiskInfo } from '../../../message-models/risk-info.interface';
import { IJobLevelInfo } from '../../../message-models/job-level.interface';
import { IRiskMatrixEntry } from '../../../message-models/risk-matrix-entry.interface';
import { OperativeInfo } from '../../../domain-model/operative-info.class';
import { HelpConsts } from '../../../help/models/help-consts';

@Component({
  selector: 'app-risk-help',
  templateUrl: './risk-help.component.html',
  styleUrls: ['./risk-help.component.scss']
})

export class RiskHelpComponent implements OnInit {
  @Input() riskMatrixEntries: IRiskMatrixEntry[] = [];
  @Input() allRisks: IRiskInfo[] = [];
  @Input() allJobLevels: IJobLevelInfo[] = [];
  @Input() operatives: OperativeInfo[] = [];
  @Input() asOfDate = '';
  @Input() heading: string = "EAS Guidance";
  @Input() companyName = '';
  @Input() isQsRole = false;
  showingHelp = false;
  easGuidanceHelpText: string = HelpConsts.EasGuidance.sections[0].body;
  isHV = false;
  lowVString = "EAS";
  lowVBS7671 = "covered by BS 7671";

  constructor(public modalRef: DynamicDialogRef) {
  }

  ngOnInit(): void {
    if (this.operatives.length === 1) {
      this.operatives.forEach(o => {
        if (o.currentOperativeTypeId === "9e693556-8c16-44a2-b1e4-2c8d18b081ad") {
          this.isHV = true;
          this.lowVString = "Risk";
          this.lowVBS7671 = "";
        }
      })
    }
  }
  getHeadingFromOperative() {
    if (this.isHV) {
      return "Risk Guidance";
    }
    return "EAS Guidance";
     
  }
  cancelClicked(): void {
    this.modalRef.close();
  }

  getJobLevelWithIndex(jobIndex: number) {
    return this.allJobLevels.find(l => l.index === jobIndex);
  }

  getRiskWithIndex(riskIndex: number) {
    return this.allRisks.find(r => r.index === riskIndex);
  }

  getOperativeNumbersInRiskRow(rowNum: number): number {
    const riskLevel = this.getRiskWithIndex(rowNum);
    if (!riskLevel) {
      return 0;
    }
    let numOps = 0;
    this.operatives.forEach(o => {
      //o.currentOperativeTypeId == hv
      if (o.currentRiskId === riskLevel.id) {
        numOps++;
      }
    });
    return numOps;
  }

  getOperativeNumbersInJobLevelRow(rowNum: number): number {
    const jobLevel = this.getJobLevelWithIndex(rowNum);
    if (!jobLevel) {
      return 0;
    }
    let numOps = 0;
    this.operatives.forEach(o => {
      if (o.currentJobLevelId === jobLevel.id) {
        numOps++;
      }
    });
    return numOps;
  }

  getRiskCellClass(rowNum: number): string {
    if (this.operatives.length !== 1) {
      return '';
    }
    const numOpsInRow = this.getOperativeNumbersInRiskRow(rowNum);
    if (numOpsInRow !== 1) {
      return '';
    }
    const riskLevel = this.getRiskWithIndex(rowNum);

    switch (riskLevel.name) {
      case 'Low':
        return 'selected-cell selected-cell-low';
      case 'Medium':
        return 'selected-cell selected-cell-warning';
      case 'High':
        return 'selected-cell selected-cell-danger';
    }
    return '';
  }

  getJobLevelCellClass(rowNum: number): string {
    if (this.operatives.length !== 1) {
      return '';
    }

    const numOpsInRow = this.getOperativeNumbersInJobLevelRow(rowNum);
    if (numOpsInRow !== 1) {
      return '';
    }

    return 'selected-cell';
  }

  showHelpClicked() {
    this.showingHelp = true;
  }
}
